import About from '../../images/about.png'
import Gcik from '../../images/gcik.svg'
import AboutText from '../../images/aboutText.png'
import PlaneCanvas from "../Canvas";
import {useWindowSize} from "../../useWindowSize";
import PlaneCanvasMobile from "../CanvasMobile";

const BlockTwo = () => {
  const width = useWindowSize().width
  return (
    <div className="h-full relative">
      <div className="w-full flex justify-between px-10 lg:px-20 min-h-[140px] lg:min-h-[300px]">
        <div className="self-baseline"></div>
        <img className="max-h-[200px] self-end w-[200px] lg:w-[400px]" alt="svg" src={AboutText}  />
      </div>
      {width > 700 ? <PlaneCanvas /> : <PlaneCanvasMobile/> }

      <div className="w-full px-4 xl:px-28 flex flex-col lg:flex-row justify-center items-center lg:justify-between mt-10 md:mt-20">
        <img className="self-center lg:self-baseline" alt="svg" src={About}  />
        <div className="max-w-full lg:max-w-[600px] border-[#FF9D00] border-[6px] rounded-2xl shadow-2xl p-4 md:p-10 relative z-40 bg-white">
          <h2 className="text-2xl md:text-3xl font-black uppercase mb-4">Our goal is to fullfill your dreams</h2>
          <img  alt="svg" src={Gcik}  />
          <p className="mt-6 text-[#313131]">“365 Travelling” is a company you can rely on and trust, providing assistance on both a creative and professional level. Leveraging our strong relationships with preferred suppliers, we often secure preferential rates for our clients. </p>
          <p className="text-[#313131] mt-6 md:mt-12">We offer a comprehensive range of outbound tourism services, including all-inclusive packages and customized solutions tailored to meet your specific needs. Our top priority is to constantly update our offerings in line with market trends and to create unique tour experiences that stand out.</p>
        </div>
      </div>
    </div>
  )
}

export default BlockTwo